var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.className,attrs:{"type":"button","title":_vm.title},on:{"click":_vm.copyBookingPortalURLHandler}},[_c('i',{staticClass:"fas fa-copy"}),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }